import { Injectable } from "@angular/core";
import { IRosterValue } from "../shared/models/roster/roster-value";
import { IRosterCode } from "../shared/models/roster-code";
import { RosterCodes } from "../shared/models/roster-codes";

@Injectable({
  providedIn: "root"
})
export class PayrollRosterCodeRecommendor{
  recommend(currentRosterValue: IRosterValue, 
    previousRosterValue: IRosterValue, 
    nextRosterValue: IRosterValue): number{
    
    if (currentRosterValue.rc?.id === RosterCodes.FIP || currentRosterValue.rc?.id === RosterCodes.DIP){
      if (nextRosterValue.rc?.id === RosterCodes.Night){
        return RosterCodes.Night;
      }else{
        return previousRosterValue.rc.id === 0 ? RosterCodes.RR : previousRosterValue.rc.id;
      }
    }

    if (currentRosterValue.rc?.id === RosterCodes.FOA || currentRosterValue.rc?.id === RosterCodes.DOA){
      return RosterCodes.RR;
    }

    if (currentRosterValue.rc?.id === RosterCodes.FIA || currentRosterValue.rc?.id === RosterCodes.DIA){
      return RosterCodes.Day;
    }

    if (currentRosterValue.rc?.id === RosterCodes.FOP || currentRosterValue.rc?.id === RosterCodes.DOP){
      return RosterCodes.Day;
    }

    return currentRosterValue.prc?.id;
  }
}